<template>
  <div class="home">
    <!-- Homepage slogan, change as you wish -->
    <HomePart msg="Progressive Hearing Protection Manufacturer" />
  </div>
</template>

<script>
// @ is an alias to /src
import HomePart from "@/components/HomePart.vue";

export default {
  name: "Home",
  metaInfo: {
    title: "Sian Plastic Protech",
    titleTemplate: null
  },
  components: {
    HomePart
  }
};
</script>

<style lang="scss" scoped></style>
